import React from 'react'
import { Chip } from 'components/ui'
import { DateToLocaleValue } from 'components/ui/DateToLocaleValue'
import { useWorkspaceText } from '../../hooks/useWorkspaceText'
import { CourseState, courseState, ICourseProgress } from '../../model/courseProgress'
import styles from './styles.module.css'

interface IExecutionCourseProgressProps {
  progress: ICourseProgress | null
}

const STATE_COLORS: Record<CourseState, string> = {
  notStarted: '#64748B',
  inProgress: '#2563EB',
  completed: '#10B981',
  passed: '#10B981',
  failed: '#EF4444',
}

/** Read-only summary of the learner's SCORM course progress, under the link's Open button. */
export function ExecutionCourseProgress({ progress }: IExecutionCourseProgressProps) {
  const t = useWorkspaceText()

  const state = courseState(progress)
  const hasScore = progress?.score !== undefined && progress?.score !== null
  const stateLabels: Record<CourseState, string> = {
    notStarted: t.statusTodo,
    inProgress: t.statusInProgress,
    // a pass is shown by its score next to the label
    completed: t.statusCompleted,
    passed: t.statusCompleted,
    failed: t.statusFailed,
  }

  return (
    <div className={styles.progress}>
      <Chip label={<>{stateLabels[state]}</>} color={STATE_COLORS[state]} dot />
      {hasScore && (
        <span className={styles.details}>
          {t.quality}
          <bdi>{progress!.score}</bdi>
        </span>
      )}
      {progress?.updated_at_ts ? (
        <span className={styles.details}>
          {t.lastRun}
          <DateToLocaleValue as="span" date={new Date(progress.updated_at_ts * 1000)} placeholder="" />
        </span>
      ) : null}
    </div>
  )
}
